import { presentLexError } from '@/lib/user-notice';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { apiFetch } from '@/lib/api';

const primaryBlue = '#1976D2';

export function RecoverPage() {
  const [username, setUsername] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setMessage('');
    if (!username.trim()) {
      setError('Indica tu usuario (correo).');
      return;
    }
    setSubmitting(true);
    try {
      const res = await apiFetch('/api/auth/recover', {
        method: 'POST',
        body: JSON.stringify({ username: username.trim() }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setError((data as { error?: string }).error || 'Error al procesar.');
        return;
      }
      setMessage((data as { message?: string }).message || 'Si el usuario existe, recibirás un correo con las instrucciones.');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error de conexión.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="lex-auth-shell" style={{ flexDirection: 'column', background: 'var(--lex-background)' }}>
      <div
        style={{
          background: primaryBlue,
          color: '#fff',
          padding: '24px 32px',
          borderRadius: 16,
          marginBottom: 24,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <i className="ri-scales-3-fill" style={{ fontSize: 40 }} aria-hidden />
        <span style={{ fontSize: 28, fontWeight: 800 }}>DUMAS</span>
        <span style={{ fontSize: 14, opacity: 0.95 }}>by DU+</span>
      </div>

      <p style={{ margin: '0 0 20px', fontSize: 16, fontWeight: 600, color: 'var(--lex-on-surface)' }}>
        Recuperar contraseña
      </p>

      <form
        onSubmit={handleSubmit}
        style={{
          width: '100%',
          maxWidth: 320,
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
        }}
      >
        <div>
          <label htmlFor="username" style={{ display: 'block', marginBottom: 4, fontSize: 14, fontWeight: 500 }}>
            Usuario (correo electrónico)
          </label>
          <input
            id="username"
            type="text"
            inputMode="email"
            autoComplete="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            disabled={submitting}
            placeholder="tu@correo.com"
            style={{
              width: '100%',
              padding: '10px 12px',
              fontSize: 16,
              border: '1px solid var(--lex-outline)',
              borderRadius: 8,
            }}
          />
        </div>
        {error ? <p style={{ margin: 0, color: '#c00', fontSize: 14 }}>{presentLexError(error)}</p> : null}
        {message ? <p style={{ margin: 0, color: 'var(--lex-primary)', fontSize: 14 }}>{message}</p> : null}
        <button
          type="submit"
          disabled={submitting}
          style={{
            padding: '12px 24px',
            background: primaryBlue,
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            fontWeight: 600,
            fontSize: 16,
            cursor: submitting ? 'wait' : 'pointer',
          }}
        >
          {submitting ? 'Enviando…' : 'Enviar instrucciones'}
        </button>
      </form>

      <Link to="/login" style={{ marginTop: 20, color: primaryBlue, fontSize: 14 }}>
        Volver a iniciar sesión
      </Link>
    </main>
  );
}
